import style from './style.css';

const EnrichCategoriesCard = ({ tileClickAction, data, index }) => {
  return (
    <div
      className={style.enrichCategoriesCard}
      onClick={() => {
        tileClickAction();
      }}>
      <div
        className={style.enrichCategoryImage}
        style={{
          backgroundImage: `url(${data.tileImgUrl ||
            (data.attributes && data.attributes.tileImgUrl)})`,
        }}
      />
      <div className={style.enrichCategoryContent}>
        <div className={style.enrichCategoryName}>{data.name}</div>
      </div>
    </div>
  );
};

export default EnrichCategoriesCard;



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/enrichCategoryCard/index.js